import React, { Fragment, useContext, useState } from "react"
import { BaseTable, Button, Card, Input, PaginationData } from "../../../../components"
import { ChildItem, CreateModal } from "./components"
import { TbChevronRight } from "react-icons/tb"
import { default_pagination_value, useToggle } from "../../../../utils"
import { Render, RenderProvider, useList } from "./utils"
import { menuTitle } from "./components/ChildItem/components/Item/components/MenuTitle"
import { debounce } from "lodash"
import { DataItem } from "./types"
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io"
import { PaginationState, dataContext } from "./utilities"

export default function TypeIndustry() {
  const [active, setActive] = useState<number | null>(null)
  const [pagination, setPagination] = useState<PaginationState>(default_pagination_value)
  const { data, isLoading, refetch } = useList(pagination)
  const onDebounce = debounce((e: any) => setPagination(prev => { return { ...prev, keyword: e.target.value } }))

  const header: any []= [
    {title: "NO", sort: false},
    {title: "CODE", sort: true},
    {title: "TYPE INDUSTRY", sort: true},
    {title: "DESCRIPTION", sort: false},
  ]

  const toggleActive = async (index: number, item: string) => {
    setActive((prevActive) => (prevActive === index ? null : index));
    const newSort = index === active ? 'asc' : 'desc';
    
    const sortBy = (field: string) => setPagination({ ...pagination, sort: `${field}:${newSort}`});

    switch (item) {
      case 'CODE': sortBy('code'); break;
      case 'TYPE INDUSTRY': sortBy('name'); break;
      default: setPagination({ ...pagination, sort: ``});
    }
  };

  return (
    <RenderProvider>
      <section className="container gap-5 flex flex-col">
      <Card>
        <Card.Body className="flex flex-row items-center justify-between !text-xl font-bold">
          <div className="bg-black p-3 text-white rounded-lg">{menuTitle.title}</div>
        </Card.Body>
      </Card>
        <Card>
          <Card.Body className="flex-row justify-end items-center">
          <Create refetch={refetch} />
          </Card.Body>

          <Card.Body>
          <div className="flex">
              <div className="mb-3">
                <Input
                  label="SEARCH"
                  className="md:max-w-[300px] w-full"
                  placeholder="Search..."
                  onChange={onDebounce}
                />
              </div>
            </div>
              <BaseTable className="table">
                <thead>
                  <tr>
                    {header.map((item, index) => (
                      <th key={index} onClick={() => item?.sort ? toggleActive(index, item?.title) : null }>
                        <div className="flex gap-2 items-center">
                          {item?.title}
                          {item?.sort && (index === active ? <IoIosArrowUp className="w-5 h-5" /> : <IoIosArrowDown className="w-5 h-5" />)}
                        </div>
                      </th>
                    ))}
                    <th className="w-[150px]">ACTION</th>
                  </tr>
                </thead>
                <tbody>
                <dataContext.Provider
                    value={{
                      currentPage: pagination.page,
                      limit: pagination.limit,
                      size: data.pagination_data.size,
                      total: pagination.total 
                    }}
                  >
                    <TableContent dataList={data} isLoading={isLoading} refetch={refetch} />
                  </dataContext.Provider>
                </tbody>
              </BaseTable>
            <div className="mt-5">
              <PaginationData data={data} pagination={pagination} setPagination={setPagination} />
            </div>
          </Card.Body>
        </Card>
      </section>
    </RenderProvider>
  )
}

function Create({ refetch }: { refetch: () => void }) {
  // const accessToken = getAccessToken("GUD");
  const { isActive, toggle } = useToggle(false)

  return (
    <Fragment>
      {/* <Button permission={!accessToken} color="primary" onClick={toggle}> */}
      <Button color="primary" onClick={toggle}>
        CREATE NEW <TbChevronRight />
      </Button>

      {isActive && <CreateModal toggle={toggle} refetch={refetch} />}
    </Fragment>
  )
}

function TableContent(props: {
  dataList: DataItem
  isLoading: boolean
  refetch: () => void
}) {
  const { render } = useContext(Render)

  if (render) {
    return <ChildItem dataList={props.dataList} isLoading={props.isLoading} refetch={props.refetch} />
  } else {
    return <div />
  }
}